<template>
	<div class="container-preview">
		<iframe v-if="isDesktop" ref="menu-iframe" id="menu-iframe"></iframe>
		<img v-if="isDesktop" src="https://img.qromo.io/img/vue/iphone.png" alt="iphone preview">
		<div v-if="loadingIframe && isDesktop" class="row centered desktop-loader-container">
			<div class="loader-wrapper">
				<AppLoader :size="20" />
			</div>
		</div>
		<AppBottomSheet id="preview-bottom-sheet" :forceWidth="bottomSheetWidth" :active="showMobilePreview" @toggling-popup="togglePreviewSheet">
			<iframe v-if="!isDesktop" v-show="!loadingIframe" ref="menu-iframe-mobile" id="menu-iframe-mobile"></iframe>
			<div v-if="loadingIframe && !isDesktop" class="row centered">
				<AppLoader :size="20" />
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppLoader from "@/shared/components/AppLoader.vue";

import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";

export default {
	setup() {
		let userStore = useUserStore();
		let menuStore = useMenuStore();
		return {
			userStore,
			menuStore
		};
	},
	name: "MenuPreview",
	data() {
		return {
			showMobilePreview: false,
			loadingIframe: false,
			loadingFallback: 0
		};
	},
	components: {AppClickableIcon, AppBottomSheet, AppLoader},
	inject: ['providedAction'],
	mixins: [WindowWidth],
	emits: ['loaded', 'fully-loaded'],
	props: {
		heatMap: {
			type: Boolean,
			default: false
		},
		alwaysMobile: {
			type: Boolean,
			default: false
		},
		generalMenu: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1024px";
			}
		},
		currentIframe() {
			return !this.isDesktop ? this.$refs["menu-iframe-mobile"] : this.$refs["menu-iframe"];
		},
		isDesktop() {
			return this.windowWidth > 768 && !this.alwaysMobile;
		}
	},
	methods: {
		refresh() {
			if(this.userStore.currBusiness && (this.menuStore.modMenu.menu_id || this.heatMap) && API.init().oauthToken) {
				let menuId = this.menuStore.modMenu.menu_id;
				let menuIdPart = menuId && !this.generalMenu ? "&menu=" + menuId : "&menu=-1";
				let id = ((parseInt(this.userStore.currBusiness.business_id) * 2133) + 17819);
				let authPart = API.init().oauthToken ? "&t="+API.init().oauthToken.substring(0, 7) : "";
				let userPart = "&u=" + this.userStore.user.user_id;
				let headMapPart = this.heatMap ? "&hm=1" : "";
				if(this.userStore.currBusiness.link) {
					this.currentIframe.src = URL_HTML + "/console/preview.php?link=" + id + menuIdPart + authPart + userPart + headMapPart;
				} else {
					this.currentIframe.src = URL_HTML + "/console/preview.php?link=" + id + menuIdPart + authPart + userPart + headMapPart;
				}
				this.checkIframeLoaded();
			}
		},
		togglePreviewSheet(sheetState) {
			this.showMobilePreview = sheetState;
			if(this.providedAction && this.providedAction.toggleMobilePreview) {
				this.providedAction.toggleMobilePreview(sheetState);
			}

		},
		checkIframeLoaded() {
			let iframeDoc = this.currentIframe && (this.currentIframe.contentDocument || this.currentIframe.contentWindow) ? this.currentIframe.contentDocument || this.currentIframe.contentWindow.document : null;
			if(iframeDoc) {
				this.loadingIframe = true;
				if (iframeDoc.readyState === 'complete') {
					this.loadingIframe = false;
					this.loadingFallback = 0;
					this.$emit('loaded');

					this.currentIframe.addEventListener('load', () => {
						this.$emit('fully-loaded');
					});
				} else {
					setTimeout(this.checkIframeLoaded, 100);
				}
			}
		},
	},
	mounted() {
		this.refresh();
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.refresh();
			}
		},
		"menuStore.modMenu.menu_id": {
			handler() {
				this.refresh();
			},
			deep: true
		},
		providedAction(newProvidedObject) {
			if(newProvidedObject.hasOwnProperty('showMobilePreview') && newProvidedObject.showMobilePreview !== this.showMobilePreview) {
				this.showMobilePreview = newProvidedObject.showMobilePreview;
			}
		},
		windowWidth(to, from) {
			if(this.isDesktop && this.showMobilePreview && this.providedAction && this.providedAction.toggleMobilePreview) {
				this.providedAction.toggleMobilePreview(false);
			}
			if(((to > 768 && from <= 768) || (to <= 768 && from > 768)) && !this.alwaysMobile) {
				requestAnimationFrame(() => {
					this.refresh();
				});
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.container-preview {
	padding: 0 12px;
	box-sizing: border-box;
	width: 100%;
	position: relative;


	iframe {
		position: absolute;
		top: 3%;
		left: 9%;
		border-radius: 5%;
		border: none;
		transform-origin: top left;
		width: 108%;
		height: 124%;
		transform: scale(0.761);
		user-select: none;

		@media (max-width: 1500px) {
			left: 10%;
			width: 139%;
			height: 163%;
			transform: scale(0.578);
		}
		@media (max-width: 1200px) {
			left: 11%;
			height: 209%;
			width: 174.8%;
			transform: scale(0.448);
		}
		@media(max-width: 960px) {
			left: 6%;
			height: 204%;
			width: 192%;
			transform: scale(0.459);
		}
	}
	img {
		position: relative;
		width: 100%;
		pointer-events: none;
		user-select: none;
	}

	.close-icon {
		display: none;
		margin: 15px 0 15px auto;
	}

	@media(max-width: 768px) {
		@include centered;
		flex-direction: column;

		.close-icon { display: block; }

		img, iframe#menu-iframe {
			display: none;
		}
	}
}
</style>

<style lang="scss">
iframe#menu-iframe-mobile {
	position: relative;
	width: 100%;
	height: calc(100vh - 125px);
	transform: none;
	border-radius: 13px;
	border: 1px solid $alpha_1;
}
#preview-bottom-sheet .bottom-sheet {
	@media(max-width: 500px) {
		padding: 10px;
	}
	@media(max-width: 400px) {
		padding: 5px;
	}
}
.desktop-loader-container {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	.loader-wrapper {
		@include centered;
		padding: 16px;
		border-radius: 13px;
		background-color: var(--color-bg);
	}
}
</style>